import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DireccioneModel } from "../../models/general/cliente.model";
import { HttpClient } from "@angular/common/http";
import { TranslateService } from "@ngx-translate/core";
import { SimpleTableConfig } from "../../../control-core/shared/simple-table/simple-table.component";
import * as cloneDeep from 'lodash/cloneDeep';

import { BuscarCiudadModel } from "../buscar-ciudad/buscar-ciudad.model";
import { UserCModel } from "../../models/user.model";
import { Subscription } from "rxjs/Subscription";
import { AuthService } from "../../../control-core/services/auth.service";
import { GeparametersService } from "../../../control-core/services/geparameters.service";
import { NGXLogger } from 'ngx-logger';
import { InputComponent } from "../../../control-core/shared/input/input.component";
import { CiudadModel, DepartamentoModel, PaisModel } from "../../models/general/gestion-geografica.model";
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ValidatorService } from "../../../control-core/services/validator-service";

import { CrearNotificacionComponent } from "../crear-notificacion/crear-notificacion.component";

@Component({
  selector: 'app-direcciones-user',
  templateUrl: 'direcciones-user.component.html'
})

/*
* Componente encargado de administrar las direcciones del cliente, permite seleccionar una direccion existente o agregar
* nuevas direcciones.
* Modo de uso:
* <app-direcciones-user
*   [(ctModel)]="direccionModel"
*   [mostrarDestinatarios]="true|false"
*   (onBuscaCiudad)= "onBuscaCiudad()">
* </app-direcciones-user>
*
* Siempre se debe validar la direccion para que el modelo se actualice, se realiza de la siguiente forma:
*
* @component({})
* export class ClassComponent {
*   @ViewChild(DireccionesUserComponent) direccionesUserComponent: DireccionesUserComponent;
*
*   constructor(){}
*
*   validarDireccion(){
*     if(this.direccionesUserComponent.checkDireccion()){
*       TODO
*     }
*   }
* }
*
* */
export class DireccionesUserComponent implements OnInit {

  @ViewChild('duc_nombres') duc_nombres: InputComponent;
  // @ViewChild(CrearNotificacionComponent) crearNotificacionComponent: CrearNotificacionComponent;

  @Input() ctModel: DireccioneModel = new DireccioneModel();
  @Input() mostrarDestinatarios = false;
  @Output('onBuscaCiudad') buscaCiudadEmit = new EventEmitter<string>();
  @Output() ctModelChange = new EventEmitter();

  checkBoxDestinatario: boolean = true;
  desSelect: boolean = false;
  mostrarFormDestinatario = false;
  mostrarTblDestinatarios = true;
  dataValidaccion = {
    error: {
      ciudad: false
    },
    text: {
      ciudad: 'SELECCIONE_CIUDAD_LABEL',
    }
  };
  configTablaDirecciones: SimpleTableConfig<DireccioneModel>;
  direccionForm: FormGroup = new FormGroup({
    nombres: new FormControl('', [Validators.required]),
    apellidos: new FormControl('', [Validators.required]),
    telefono: new FormControl('', [Validators.required, this._validatorService.soloNumerosFormValidator]),
    zip: new FormControl('', [Validators.required]),
    direccion: new FormControl('', [Validators.required])
  });

  private _model: DireccioneModel;
  private _ciudad: BuscarCiudadModel = new BuscarCiudadModel(new CiudadModel(), new DepartamentoModel(), new PaisModel());
  private _objCliente$Unsubscribe: Subscription;
  private _userInfo: UserCModel;

  constructor(private _http: HttpClient,
              private _translate: TranslateService,
              private _parameters: GeparametersService,
              private _authService: AuthService,
              private _validatorService: ValidatorService,
              private _logger: NGXLogger) {
  }

  ngOnInit() {
    this.configTablaDirecciones = new SimpleTableConfig();
    this.configTablaDirecciones.allowSelectRow = true;
    this.configTablaDirecciones.columns = [
      {
        label: '', name: 'direccion', options: {
          render: (data, idx, rowData) => {
            let zipCode = this._validatorService.isEmpty(rowData.zip) ? '' : rowData.zip;
            let nombres_destinatario = '';
            if (rowData.nombres != null) {
              nombres_destinatario = rowData.nombres + " " + rowData.apellidos;
            } else {
              rowData.nombres = this._userInfo.name;
              rowData.apellidos = this._userInfo.lastname;
              rowData.telefono = this._userInfo.telefono;
              nombres_destinatario = this._userInfo.name + " " + this._userInfo.lastname;
            }
            return '<h5>' + nombres_destinatario.toUpperCase() + '</h5>'
                  + rowData.ciudad.nombre
                  + ' - ' + rowData.direccion;
            // return '<h5>' + nombres_destinatario.toUpperCase() + '</h5>'
            //     + rowData.ciudad.nombre
            //     + ' - ' + rowData.ciudad.departamento.nombre
            //     + ' - ' + rowData.ciudad.departamento.pais.nombre
            //     + '<br>' + rowData.telefono
            //     + '<br>' + rowData.direccion
            //     + '<br>' + zipCode;
          }
        }
      }
    ];
    this._objCliente$Unsubscribe = this._authService.userInfo$
        .subscribe((iUserInfo: UserCModel) => {
          this._userInfo = iUserInfo;
          this.configTablaDirecciones.data.splice(0, this.configTablaDirecciones.data.length);
          let ctrlDirecciones = [];
          this._userInfo.direcciones.forEach((value) => {
            value.gecliente_id = this._userInfo.id;
            value.idbox = this._userInfo.idbox;
            value.email = this._userInfo.email;
            value.identificacion = this._userInfo.identificacion;
            this.configTablaDirecciones.data.push(value);
            ctrlDirecciones[value.direccion + "" + value.zip + "" + value.geciudade_id] = true;
          });
          this._userInfo.dir_envios.forEach((value) => {
            let canPush = this._validatorService.isEmpty(ctrlDirecciones[value.direccion + "" + value.zip + "" + value.geciudade_id]);
            if (canPush) {
              this.configTablaDirecciones.data.push(value);
            }
          });
          ctrlDirecciones.splice(0, ctrlDirecciones.length);
        });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.ctModel != null && changes.ctModel.currentValue != null) {
      this.model = changes.ctModel.currentValue;
      if(this.model.ciudad){
        this._ciudad.setFromCiudadModel(cloneDeep(this.model.ciudad));
      }
      this.direccionForm.setValue({
        nombres: this.model.nombres,
        apellidos: this.model.apellidos,
        telefono: this.model.telefono,
        zip: this.model.zip,
        direccion: this.model.direccion,
      })
    }
  }

  checkDireccion = () => {
    let valida = true;
    this._resetearValidacion();
    if (this._validatorService.isEmpty(this.ciudad.ciudad_id)) {
      this.dataValidaccion.error.ciudad = true;
      valida = false;
    }
    if (this.direccionForm.valid) {
      for (let key in this.direccionForm.value) {
        if (!this.direccionForm.value.hasOwnProperty(key)) continue;
        this._model[key] = this.direccionForm.value[key];
      }
      this.ctModelChange.emit(this._model);
    } else {
      valida = false;
    }
    return valida;
  };

  ngOnDestroy = () => {
    this._objCliente$Unsubscribe.unsubscribe();
  };

  onDireccionSeleccionada = (row) => {
    // this.mostrarFormDestinatario = true;
    // this.mostrarTblDestinatarios = false;
    this.desSelect = true;
    this.checkBoxDestinatario = false;
    let dataRow = cloneDeep(row);
    if (this._validatorService.isEmpty(row)) {
      this.ciudad = new BuscarCiudadModel(row.ciudad, row.departamento, row.pais);
      dataRow = new DireccioneModel();
      this.direccionForm.reset();
    } else {
      this.ciudad.setFromCiudadModel(cloneDeep(dataRow.ciudad));
      this._resetearValidacion();
      this.direccionForm.setValue({
        nombres: dataRow.nombres,
        apellidos: dataRow.apellidos,
        telefono: dataRow.telefono,
        zip: dataRow.zip,
        direccion: dataRow.direccion
      })
    }
    this.model = dataRow;
  };

  onChange = () => {
    this.checkBoxDestinatario = false;
    if (this.mostrarTblDestinatarios) {
      this.mostrarTblDestinatarios = false;
      this.mostrarFormDestinatario = true;
      this.desSelect = false;
      // return "in if"
    } else if (!this.mostrarTblDestinatarios) {
      this.mostrarTblDestinatarios = true;
      this.mostrarFormDestinatario = false;
      this.desSelect = true;
      // return "in else if"
    }
    return false
  }

  onBuscaCiudad = (texto) => {
    this.buscaCiudadEmit.emit(texto);
  };

  limpiarDireccion = () => {
    this.duc_nombres.setFocus();
    this.direccionForm.reset();
    this.model = new DireccioneModel();
  };

  private _resetearValidacion = () => {
    for (let key in this.dataValidaccion.error) {
      if (!this.dataValidaccion.error.hasOwnProperty(key)) continue;
      this.dataValidaccion.error[key] = false;
    }
  };

  get model(): DireccioneModel {
    return this._model;
  };

  set model(direccion: DireccioneModel) {
    this.ctModelChange.emit(direccion);
    this._model = direccion;
  };

  get ciudad(): BuscarCiudadModel {
    return this._ciudad;
  };

  set ciudad(value: BuscarCiudadModel) {
    this._ciudad = new BuscarCiudadModel(value.ciudad, value.estado, value.pais);
    this._model.geciudade_id = this._ciudad.ciudad_id;
    this._model.ciudad = this._ciudad.getCiudadModel();
    this.ctModelChange.emit(this._model);
  };

}


// WEBPACK FOOTER //
// ./src/app/control-app/shared/direcciones-user/direcciones-user.component.ts